import { Id } from 'react-toastify';

import { useMutation } from '@tanstack/react-query';

import { notificationService } from 'services';

export const useDeleteNotification = () => {
  const { mutateAsync: deleteNotification } = useMutation({
    mutationFn: (id: Id) => notificationService.deleteNotification(id),
  });

  return { deleteNotification };
};
